import React, { useEffect, useState, useContext } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { AuthContext } from "../../context/authContext/authContext";

import MUIDataTable from "mui-datatables";
import { IconButton, Popover, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import RemoveIcon from "@mui/icons-material/Remove";

import "moment/locale/es-mx";
import Filtros from "../../components/Filtros";
import { Spinner } from "../../components/Spinner";
import { AddTiendas } from "../../components/customComponents/Modals/AddTiendas";

const columns = [
  { name: "Tienda", label: "Tienda" },
  { name: "Domicilio", label: "Domicilio" },
  { name: "Estado", label: "Estado" },
  { name: "Municipio", label: "Municipio" },
  { name: "Cliente", label: "Cliente" },
];

// Toolbar con popup que recibe props
const ToolbarPopup = ({ negocioId, handleChange, setActiModalTienda }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { user } = useContext(AuthContext);

  const handleClick = (event) =>
    setAnchorEl(anchorEl ? null : event.currentTarget);

  const open = Boolean(anchorEl);
  const id = open ? "popup-empty" : undefined;

  return (
    <>
      {[1, 2].includes(parseInt(user.negocio_id)) && (
        <IconButton
          onClick={handleClick}
          title={open ? "Cerrar Filtros Cliente" : "Abrir Filtros Cliente"}
        >
          {open ? <RemoveIcon /> : <TuneIcon />}
        </IconButton>
      )}

      <IconButton onClick={() => setActiModalTienda(true)} title="Crear Tienda">
        <AddIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Box sx={{ bgcolor: "white" }} />
        <div style={{ padding: 16, maxWidth: 600 }}>
          <Filtros
            config={["negocio"]}
            valores={{ negocioId }}
            onChange={handleChange}
          />
        </div>
      </Popover>
    </>
  );
};

export const TableroTiendas = () => {
  useCeo({
    title: "Módulo de Administración de tiendas",
    description: "Página de tiendas",
  });

  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [negocioId, setNegocioId] = useState(user.negocio_id);
  const [cliente, setCliente] = useState("");
  const [loading, setLoading] = useState(false);

  const [actiModalTienda, setActiModalTienda] = useState(false);
  const modalTiendaClose = () => setActiModalTienda(false);

  const handleTiendaSaved = () => {
    setActiModalTienda(false);
    // Aquí podrías recargar datos si lo deseas
  };

  const { getTiendasNegocio } = useUnidades();

  const handleChange = (campo, valor) => {
    if (campo === "negocio") setNegocioId(valor);
  };

  const options = {
    selectableRows: "none",
    responsive: "standard",
    fixedHeader: true,
    downloadOptions: {
      filename: `TIENDAS EN BITÁCORA`,
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      },
      charset: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) =>
      "\uFEFF" + buildHead(columns) + buildBody(data),
    // 👇 aquí el cambio clave
    customToolbar: () =>
      !loading ? ( // solo se muestra cuando ya cargó
        <ToolbarPopup
          negocioId={negocioId}
          handleChange={handleChange}
          setActiModalTienda={setActiModalTienda}
        />
      ) : null,
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  useEffect(() => {
    if (!negocioId) return;
    setLoading(true);
    setData([]);

    const fetchData = async () => {
      try {
        const resp = await getTiendasNegocio(negocioId);
        setCliente(resp.cliente || "");

        if (resp.ok && Array.isArray(resp.tiendas)) {
          const array = resp.tiendas.map(
            ({ tienda_nombre, domicilio, estado, municipio, negocio }) => [
              tienda_nombre || "N/A",
              domicilio || "N/A",
              estado || "N/A",
              municipio || "N/A",
              negocio?.negocio_nombre || "N/A",
            ]
          );
          setData(array);
        } else {
          setData([]);
        }
      } catch (error) {
        console.error("Error al cargar bitácora:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [negocioId]);

  return (
    <>
      {loading && <Spinner />}
      <div>
        <MUIDataTable
          title={loading ? "Cargando..." : `Tiendas en Bitácora ${cliente}`}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
      <AddTiendas
        show={actiModalTienda}
        handleClose={modalTiendaClose}
        onTiendaSaved={handleTiendaSaved}
        cedis_id={null}
        idNegocio={negocioId}
      />
    </>
  );
};
